import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const Container = styled.div`
  width: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  padding: 12px 0px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
`;

const MenuItem = styled.div<{ isActived?: boolean }>`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -0.4px;
  color: #939090;
  margin-bottom: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;

  :hover {
    color: #ffffff;

    a {
      color: #ffffff;
    }

    svg {
      fill: #ffffff;
    }
  }

  a {
    color: #939090;
    text-decoration: none;
  }

  svg {
    fill: #939090;
  }

  ${({ isActived }) =>
    isActived &&
    css`
      a {
        color: #ffffff;
      }

      svg {
        fill: #ffffff;
      }
    `}
`;

export const SideMenu = () => {
  const isExactPath = (path: string) => {
    return window.location.pathname === path;
  };

  const isContainsPath = (path: string) => {
    return window.location.pathname.includes(path);
  };

  return (
    <Container>
      <MenuItem isActived={isExactPath('/admin') || isContainsPath('/admin/organization')}>
        {Icons.organizations()}
        <Link to={'/admin'}>Organizações</Link>
      </MenuItem>
      <MenuItem isActived={isContainsPath('/admin/applications')}>
        {Icons.applications()}
        <Link to={'/admin/applications'}>Aplicações</Link>
      </MenuItem>
      <MenuItem isActived={isContainsPath('/admin/accounts')}>
        {Icons.users()}
        <Link to={'/admin/accounts'}>Contas</Link>
      </MenuItem>
      <MenuItem isActived={isExactPath('/admin/roles')}>
        {Icons.roles()}
        <Link to={'/admin/roles'}>Papéis</Link>
      </MenuItem>
      <MenuItem isActived={isExactPath('/admin/scopes')}>
        {Icons.scopes()}
        <Link to={'/admin/scopes'}>Escopos</Link>
      </MenuItem>
      <MenuItem isActived={isContainsPath('/admin/invitations')}>
        {Icons.invites()}
        <Link to={'/admin/invitations'}>Convites</Link>
      </MenuItem>
      <MenuItem isActived={isContainsPath('/admin/sso/registrations')}>
        {Icons.ssoRegistrations()}
        <Link to={'/admin/sso/registrations'}>SSO</Link>
      </MenuItem>
    </Container>
  );
};

const Icons = {
  organizations: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M226-160q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19ZM226-414q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19ZM226-668q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Zm254 0q-28 0-47-19t-19-47q0-28 19-47t47-19q28 0 47 19t19 47q0 28-19 47t-47 19Z" />
    </svg>
  ),
  applications: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z" />
    </svg>
  ),
  users: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z" />
    </svg>
  ),
  invites: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M480-440 160-640v400h360v80H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v280h-80v-200L480-440Zm0-80 320-200H160l320 200ZM760-40l-56-56 63-64H600v-80h167l-64-64 57-56 160 160L760-40ZM160-640v440-240 3-283 80Z" />
    </svg>
  ),
  roles: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
    </svg>
  ),
  scopes: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h420v-140H160v140Zm500 0h140v-360H660v360ZM160-460h420v-140H160v140Z" />
    </svg>
  ),
  ssoRegistrations: () => (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path d="M120-160v-112q0-34 17.5-62.5T184-378q62-31 126-46.5T440-440q20 0 40 1.5t40 4.5q-4 58 21 109.5t73 84.5v80H120ZM760-40l-60-60v-186q-44-13-72-49.5T600-420q0-58 41-99t99-41q58 0 99 41t41 99q0 45-25.5 80T790-290l50 50-60 60 60 60-80 80ZM440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm300 80q17 0 28.5-11.5T780-440q0-17-11.5-28.5T740-480q-17 0-28.5 11.5T700-440q0 17 11.5 28.5T740-400Z" />
    </svg>
  ),
};
